import React, { useEffect } from "react";
import CheckEligibility from "../views/eligibilityCheck/check_eligibility";
import StmSummary from "../views/shared/storefront-summary";
import Eligibility from "../views/eligibility/eligibility.component";
import checkModule from "../views/shared/checkModule";


// import CheckEligibility from "../views/eligibilityCheck copy/check_eligibility";

const EligibilityCheckUI = (props) => {

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [])

  return (
    <div className="storefront-two-col-pg">
      {checkModule.isEligibilityKw ? <CheckEligibility history={props.history} /> :
        null}
      {checkModule.isEligibilityKsa ?
        <Eligibility /> : null}
      <StmSummary />
    </div>
  );
};

export default EligibilityCheckUI;
